import { useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

import createContentfulClient from '@glass/shared/modules/apollo/createContentfulClient';

const useContentfulQuery = (query, options = {}) => {
  const { isPreview: preview } = useRouter();

  const client = useMemo(() => createContentfulClient({ preview }), [preview]);

  const apolloOptions = useMemo(
    () => ({
      ...options,
      variables: {
        ...(options.variables || {}),
        preview,
      },
      client,
    }),
    [client, preview, options],
  );

  return useQuery(query, apolloOptions);
};

export default useContentfulQuery;
